export const EVENT_VIRTUAL = 'Online';
